// extracted by mini-css-extract-plugin
module.exports = {"ant-modal-content":"LoginForm_ant-modal-content__3DNta","BtnLogin":"LoginForm_BtnLogin__1QM_Y","Input":"LoginForm_Input__k1JxH"};